/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChipDto } from '../models/chip-dto';
import { createChip$Json } from '../fn/chip/create-chip-json';
import { CreateChip$Json$Params } from '../fn/chip/create-chip-json';
import { createChip$Plain } from '../fn/chip/create-chip-plain';
import { CreateChip$Plain$Params } from '../fn/chip/create-chip-plain';
import { deleteChip } from '../fn/chip/delete-chip';
import { DeleteChip$Params } from '../fn/chip/delete-chip';
import { getAllAvailableChips$Json } from '../fn/chip/get-all-available-chips-json';
import { GetAllAvailableChips$Json$Params } from '../fn/chip/get-all-available-chips-json';
import { getAllAvailableChips$Plain } from '../fn/chip/get-all-available-chips-plain';
import { GetAllAvailableChips$Plain$Params } from '../fn/chip/get-all-available-chips-plain';
import { getAllChips$Json } from '../fn/chip/get-all-chips-json';
import { GetAllChips$Json$Params } from '../fn/chip/get-all-chips-json';
import { getAllChips$Plain } from '../fn/chip/get-all-chips-plain';
import { GetAllChips$Plain$Params } from '../fn/chip/get-all-chips-plain';
import { restrictChip$Json } from '../fn/chip/restrict-chip-json';
import { RestrictChip$Json$Params } from '../fn/chip/restrict-chip-json';
import { restrictChip$Plain } from '../fn/chip/restrict-chip-plain';
import { RestrictChip$Plain$Params } from '../fn/chip/restrict-chip-plain';
import { unrestrictChip$Json } from '../fn/chip/unrestrict-chip-json';
import { UnrestrictChip$Json$Params } from '../fn/chip/unrestrict-chip-json';
import { unrestrictChip$Plain } from '../fn/chip/unrestrict-chip-plain';
import { UnrestrictChip$Plain$Params } from '../fn/chip/unrestrict-chip-plain';

@Injectable({ providedIn: 'root' })
export class ChipApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllAvailableChips()` */
  static readonly GetAllAvailableChipsPath = '/v1/chips/available';

  /**
   * Holt alle verfügbaren Chips.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAvailableChips$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAvailableChips$Plain$Response(params?: GetAllAvailableChips$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
    return getAllAvailableChips$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle verfügbaren Chips.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAvailableChips$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAvailableChips$Plain(params?: GetAllAvailableChips$Plain$Params, context?: HttpContext): Observable<Array<ChipDto>> {
    return this.getAllAvailableChips$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChipDto>>): Array<ChipDto> => r.body)
    );
  }

  /**
   * Holt alle verfügbaren Chips.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAvailableChips$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAvailableChips$Json$Response(params?: GetAllAvailableChips$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
    return getAllAvailableChips$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle verfügbaren Chips.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAvailableChips$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAvailableChips$Json(params?: GetAllAvailableChips$Json$Params, context?: HttpContext): Observable<Array<ChipDto>> {
    return this.getAllAvailableChips$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChipDto>>): Array<ChipDto> => r.body)
    );
  }

  /** Path part for operation `getAllChips()` */
  static readonly GetAllChipsPath = '/v1/chips/all';

  /**
   * Holt alle Chips.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllChips$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllChips$Plain$Response(params?: GetAllChips$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
    return getAllChips$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Chips.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllChips$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllChips$Plain(params?: GetAllChips$Plain$Params, context?: HttpContext): Observable<Array<ChipDto>> {
    return this.getAllChips$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChipDto>>): Array<ChipDto> => r.body)
    );
  }

  /**
   * Holt alle Chips.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllChips$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllChips$Json$Response(params?: GetAllChips$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
    return getAllChips$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Chips.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllChips$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllChips$Json(params?: GetAllChips$Json$Params, context?: HttpContext): Observable<Array<ChipDto>> {
    return this.getAllChips$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChipDto>>): Array<ChipDto> => r.body)
    );
  }

  /** Path part for operation `createChip()` */
  static readonly CreateChipPath = '/v1/chips';

  /**
   * Erstellt einen neuen Chip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createChip$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  createChip$Plain$Response(params?: CreateChip$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
    return createChip$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Erstellt einen neuen Chip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createChip$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createChip$Plain(params?: CreateChip$Plain$Params, context?: HttpContext): Observable<ChipDto> {
    return this.createChip$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChipDto>): ChipDto => r.body)
    );
  }

  /**
   * Erstellt einen neuen Chip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createChip$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  createChip$Json$Response(params?: CreateChip$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
    return createChip$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Erstellt einen neuen Chip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createChip$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createChip$Json(params?: CreateChip$Json$Params, context?: HttpContext): Observable<ChipDto> {
    return this.createChip$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChipDto>): ChipDto => r.body)
    );
  }

  /** Path part for operation `restrictChip()` */
  static readonly RestrictChipPath = '/v1/chips/restrict';

  /**
   * Sperrt einen Chip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restrictChip$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  restrictChip$Plain$Response(params?: RestrictChip$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
    return restrictChip$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sperrt einen Chip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restrictChip$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  restrictChip$Plain(params?: RestrictChip$Plain$Params, context?: HttpContext): Observable<ChipDto> {
    return this.restrictChip$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChipDto>): ChipDto => r.body)
    );
  }

  /**
   * Sperrt einen Chip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restrictChip$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  restrictChip$Json$Response(params?: RestrictChip$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
    return restrictChip$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sperrt einen Chip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restrictChip$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  restrictChip$Json(params?: RestrictChip$Json$Params, context?: HttpContext): Observable<ChipDto> {
    return this.restrictChip$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChipDto>): ChipDto => r.body)
    );
  }

  /** Path part for operation `unrestrictChip()` */
  static readonly UnrestrictChipPath = '/v1/chips/{chipNr}/unrestrict';

  /**
   * Entsperrt einen Chip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unrestrictChip$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  unrestrictChip$Plain$Response(params: UnrestrictChip$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
    return unrestrictChip$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Entsperrt einen Chip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unrestrictChip$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unrestrictChip$Plain(params: UnrestrictChip$Plain$Params, context?: HttpContext): Observable<ChipDto> {
    return this.unrestrictChip$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChipDto>): ChipDto => r.body)
    );
  }

  /**
   * Entsperrt einen Chip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unrestrictChip$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  unrestrictChip$Json$Response(params: UnrestrictChip$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
    return unrestrictChip$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Entsperrt einen Chip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unrestrictChip$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unrestrictChip$Json(params: UnrestrictChip$Json$Params, context?: HttpContext): Observable<ChipDto> {
    return this.unrestrictChip$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChipDto>): ChipDto => r.body)
    );
  }

  /** Path part for operation `deleteChip()` */
  static readonly DeleteChipPath = '/v1/chips/{chipNr}';

  /**
   * Löscht einen Chip. Wenn der Chip einem Externen zugewiesen ist, werden auch der Externe und alle Personenzugänge gelöscht. Zutrittskontrolle-Events bleiben erhalten.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteChip()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteChip$Response(params: DeleteChip$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteChip(this.http, this.rootUrl, params, context);
  }

  /**
   * Löscht einen Chip. Wenn der Chip einem Externen zugewiesen ist, werden auch der Externe und alle Personenzugänge gelöscht. Zutrittskontrolle-Events bleiben erhalten.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteChip$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteChip(params: DeleteChip$Params, context?: HttpContext): Observable<void> {
    return this.deleteChip$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
